var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockTag = function SvgLockTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.666 490.667c0 11.776 9.536 21.333 21.333 21.333h384c11.797 0 21.333-9.557 21.333-21.333v-64H42.666zM350.166 384h119.168V264.832zM161.834 256h60.331l-128 128h67.669l128-128h60.331l-128 128h67.669l167.979-167.979c-2.987-1.579-6.208-2.688-9.813-2.688h-42.667v-64C405.332 66.987 338.324 0 255.999 0S106.666 66.987 106.666 149.333v64H63.999c-11.797 0-21.333 9.557-21.333 21.333V384a21.28 21.28 0 0 1 6.251-15.083zm-12.502-106.667c0-58.816 47.851-106.667 106.667-106.667s106.667 47.851 106.667 106.667v64H149.332z"
  })));
};
export default SvgLockTag;